<template>
  <aside class="member-col">
    <div class="member-col__head">
      <p>慢病会员</p>
      <div class="search" @click="$emit('search')">
        <i class="el-icon-search"></i>
        <input
          :value="value"
          type="text"
          placeholder="搜索姓名或手机号"
          @input="$emit('input', $event.target.value)"
          @keyup.enter="$emit('search')"
        />
      </div>
    </div>
    <div class="member-col__list">
      <button
        v-for="item in members"
        :key="item.id"
        type="button"
        class="member-item"
        :class="{ 'is-on': item.id === selectedId }"
        @click="$emit('select', item.id)"
      >
        <div class="member-item__top">
          <span class="avatar">{{ shortName(item.name) }}</span>
          <span class="meta">
            <span class="name-line">
              <strong>{{ item.name }}</strong>
              <i class="risk" :class="riskClass(item.risk)">{{ item.risk }}</i>
            </span>
            <em>{{ item.phone }}</em>
          </span>
        </div>
        <div class="member-item__score">
          <span>健康评分</span>
          <strong>{{ item.score }}分</strong>
        </div>
      </button>
      <el-empty v-if="!members.length" description="没有匹配的会员" :image-size="72" />
    </div>
  </aside>
</template>

<script>
/** 左侧慢病会员列表，搜索回车或点搜索图标触发 */
import { shortName, riskClass } from '../helpers';

export default {
  name: 'MemberList',
  props: {
    value: { type: String, default: '' },
    members: { type: Array, default: () => [] },
    selectedId: { type: [Number, String], default: null }
  },
  methods: { shortName, riskClass }
};
</script>
